// Renewal day — sent once the policy has renewed. Email only, no pricing; the CTA
// points at My Portal. NOT marketing, so it never carries an unsubscribe link.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) => "You're renewed — your documents are ready in My Portal";

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Your renewal documents are ready",
    cta: { label: "View my documents in My Portal", url: "https://www.myportal.co.uk/" },
    bodyHtml: body(
      p(
        `Thank you for renewing with ${brand.name}. Cover for ${b(`'${esc(data.companyName)}'`)} continues from ${b(longDate(data.renewalDate))} — you're all set for the year ahead.`,
      ),
      p(
        `Your renewal documents are now ready to view and download in your ${b("My Portal")} account at ${b("www.myportal.co.uk")} — including your policy schedule, statement of price and terms of business. Please check them and keep a copy for your records.`,
      ),
      p(
        `If anything needs updating — your address, contact details or the cover your business needs — just call our UK-based team on ${call(brand)} and we'll sort it.`,
      ),
    ),
  });
